<template>
  <rg-deselect-all-button
    class="aisea-text-12-400-pure-white"
    :style="buttonStyle"
    buttonText="選択を全て解除"
    @deselect-all="deselectAll"
  ></rg-deselect-all-button>
</template>

<script>
import RgDeselectAllButton from "./RgDeselectAllButton.vue";
import { EVENTS } from "./RgDeselectAllButton.vue";

const DEFAULT_STYLE = {
  position: "absolute",
  top: "45px",
  left: "357px",
  "z-index": 3,
};

export default {
  name: "RgDeselectAllButtonContainer",

  props: {
    isMobileDevice: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    RgDeselectAllButton,
  },

  methods: {
    deselectAll() {
      this.$emit(EVENTS.DESELECT_ALL);
    },
  },

  computed: {
    buttonStyle() {
      return this.isMobileDevice ? DEFAULT_STYLE : DEFAULT_STYLE;
    },
  },
};
</script>

<style lang="scss" scoped></style>
